import theme from "/opt/build/repo/src/style/theme.js";
export default theme;
